import ApeHostNotifications from '~/_base/functions/apeHostNotifications';
// This class interfaces with the android host via ApeHostNotifcations, but
// it will only be used if the native speech recognition stuff is missing
// (this is most likely only the case in the UWP and old android devices)
//
//
// The SpeechRecognition class has many options and methods, but this shim
// supports only a cut down subset.
//
// The following options are supported:
//
// - this.maxAlternatives : the number of alternative transcripts to send
// - this.lang : the locale, if not specified the device default will be used
// - interimResults : trigger onresult as the user is talking with interim transacripts
//
class SpeechRecognitionShim {
  constructor() {
    this._id = '1';
    this.interimResults = true;

    this.onstart = function() {};
    this.onresult = function() {};
    this.onerror = function() {};
    this.onend = function() {};

    // need to set a global object, so that we can call into it
    window[this._name] = this;
    this._notifyHost({
      type: 'newSpeechRecognition',
      id: this._id,
      name: 'window.' + this._name,
    });
  }

  get _name() {
    return `speechRecognition_${this._id}`;
  }

  start() {
    this._notifyHost({
      type: 'startSpeechRecognition',
      id: this._id,
      options: this,
    });
  }

  stop() {
    this._notifyHost({
      type: 'stopSpeechRecognition',
      id: this._id,
      options: this,
    });
  }

  _notifyHost(o) {
    ApeHostNotifications.notify(o);
  }
}

const DefaultSpeechRecognition =
  window.SpeechRecognition ||
  window.webkitSpeechRecognition ||
  SpeechRecognitionShim;

export { DefaultSpeechRecognition, SpeechRecognitionShim };
